<template>
  <div class="side-menu noprint">
    <el-aside>
      <el-menu
        :default-active="activeMenuItem"
        :default-openeds="defaultExp"
        class="el-menu-vertical-demo"
        :collapse="isCollapse"
      >
        <template v-for="obj in menuList">
          <el-menu-item
            class="el-submenu__title"
            v-if="obj.item.length == 0"
            :key="obj.name"
            :index="obj.name"
            @click="navigate(obj.path)"
          >
            <i :class="obj.icon" class="module-icon"></i>
            <span slot="title">{{ obj.groupTitle }}</span>
          </el-menu-item>

          <el-submenu :class="isCollapse ? 'el-submenu__title' : ''" style="padding: 0;" :index="obj.name" :key="obj.name" popper-class="popMenu" v-else>
            <template slot="title">
              <i :class="obj.icon" class="module-icon"></i>
              <span slot="title">{{ obj.groupTitle }}</span>
            </template>

            <el-menu-item
              v-for="item in obj.item"
              :key="item.name"
              :index="item.name"
              @click="navigate(item.path)"
            >
              <i :class="item.icon" class="module-icon"></i>
              {{ item.groupTitle }}
            </el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
    </el-aside>
    <div class="drawer-btn">
      <a @click="drawerShow">
        &nbsp;
        <i :class="isCollapse ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></i>
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { buildSideMenu } from "./sideMenu.js";
import "./aside.less";

export default {
  name: "side-menu",
  props: {
    isCollapse: Boolean,
  },
  data() {
    return {
      currentUrl: window.location.pathname || "",
    };
  },
  computed: {
    ...mapState("app", {
      adminType: state => state.adminType,
      brandCode: state => state.brandCode,
    }),
    menuList() {
      return buildSideMenu(this.adminType, this.brandCode);
    },
    activeMenuItem() {
      return this.sideMenuOption("ACT_ITEM");
    },
    defaultExp() {
      return this.sideMenuOption();
    },
  },
  methods: {
    navigate(route) {
      if (this.$route.path != route) {
        this.$router.push({ path: route });
      }
    },
    drawerShow() {
      this.$emit("collapseAction");
    },
    sideMenuOption(type) {
      let actMenu = "";
      let defaultOpens = [];

      if (this.adminType) {
        for (let i = 0; i < this.menuList.length; i++) {
          if (this.menuList[i].path == this.currentUrl) {
            actMenu = this.menuList[i].name;
            break;
          }

          if (this.menuList[i].item.length > 0) {
            for (let j = 0; j < this.menuList[i].item.length; j++) {
              if (this.menuList[i].item[j].path == this.currentUrl) {
                actMenu = this.menuList[i].item[j].name;
                defaultOpens = [ this.menuList[i].name ];
                break;
              }
            }

            if (defaultOpens.length > 0) {
              break;
            }
          }
        }
      }

      return type === "ACT_ITEM" ? actMenu : defaultOpens;
    },
  },
  mounted() {},
  watch: {
    $route(to) {
      const nonAuth = ["/", "/login"];
      if (nonAuth.includes(to.path)) {
        this.menuList = [];
        this.actMenu = "";
      } else {
        this.currentUrl = to.path;
      }
    },
  }
};
</script>
